module.exports = __webpack_public_path__ + "static/media/collapse.5ef8ecb6.svg";